;
define("product_list_control_new_item.tpl", function(){});

